var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import ContentLoader from "react-content-loader";
import * as React from "react";
import styled from "styled-components";
import TopInfoBar from "./TopInfoBar";
import SubmitButton from "./SubmitButton";
import { useTypedSelector } from "../../state/store";
import LoginPrompt from "./LoginPrompt";
var ContentWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 1rem;\n"], ["\n  padding: 1rem;\n"])));

var LoadingQuiz = function LoadingQuiz(_a) {
  var content = _a.content,
      accessToken = _a.accessToken;
  var displayBars = useTypedSelector(function (state) {
    return state.loadingBars;
  });

  if (content && content.Loading) {
    return React.createElement(React.Fragment, null, content.Loading);
  }

  return React.createElement("div", null, React.createElement(TopInfoBar, null), !accessToken && React.createElement(LoginPrompt, {
    content: content && content.Login,
    fullQuizInfoShown: true
  }), React.createElement(ContentWrapper, null, displayBars ? React.createElement(ContentLoader, {
    height: 200,
    width: 400,
    speed: 2,
    backgroundColor: "#000000",
    backgroundOpacity: 0.12,
    foregroundColor: "#000000",
    foregroundOpacity: 0.26,
    style: {
      height: "400px"
    }
  }, React.createElement("rect", {
    x: "0",
    y: "15",
    rx: "4",
    ry: "4",
    width: "360",
    height: "6"
  }), React.createElement("rect", {
    x: "0",
    y: "35",
    rx: "3",
    ry: "3",
    width: "365",
    height: "6"
  }), React.createElement("rect", {
    x: "0",
    y: "55",
    rx: "3",
    ry: "3",
    width: "125",
    height: "6"
  }), React.createElement("rect", {
    x: "0",
    y: "100",
    rx: "3",
    ry: "3",
    width: "348",
    height: "6"
  }), React.createElement("rect", {
    x: "0",
    y: "120",
    rx: "3",
    ry: "3",
    width: "380",
    height: "6"
  }), React.createElement("rect", {
    x: "0",
    y: "140",
    rx: "3",
    ry: "3",
    width: "222",
    height: "6"
  }), React.createElement("rect", {
    x: "0",
    y: "160",
    rx: "3",
    ry: "3",
    width: "370",
    height: "6"
  }), React.createElement("rect", {
    x: "0",
    y: "180",
    rx: "3",
    ry: "3",
    width: "340",
    height: "6"
  })) : React.createElement("div", {
    style: {
      height: "400px"
    }
  }), accessToken && React.createElement(SubmitButton, null)));
};

export default LoadingQuiz;
var templateObject_1;